import React from 'react';

import { Link } from 'gatsby';

import { NavigationLinks } from '@mewa/types';
import { ServiceSegmentsOverview, ServiceSegmentsTheme } from '@mewa/ui';

import { jpgPath } from '../../helpers/image-factory';
import {
  CardAssets,
  HeaderAndFooterTranslations,
  ServiceSegmentLink,
} from '../header/types';
import {
  getServiceSegmentImage,
  SERVICE_SEGMENT_IMAGE_HEIGHT,
  SERVICE_SEGMENT_IMAGE_WIDTH,
} from './service-segment-images';

type ServiceSegmentsOverviewProps = {
  clothingServiceSegments: (ServiceSegmentLink & CardAssets)[];
  nonClothingServiceSegments: (ServiceSegmentLink & CardAssets)[];
  langPrefix: string;
  headerAndFooterTranslations: HeaderAndFooterTranslations;
  navigationLinks: NavigationLinks;
  className?: string;
  headline: string;
  theme?: ServiceSegmentsTheme;
};

export const ServiceSegmentsOverviewWrapper = ({
  clothingServiceSegments,
  nonClothingServiceSegments,
  langPrefix,
  headerAndFooterTranslations,
  navigationLinks,
  headline,
  theme = 'light',
}: ServiceSegmentsOverviewProps) => {
  const tagsLeft = clothingServiceSegments.map((segment) => ({
    label: segment.name,
    props: { to: `${langPrefix}/${segment.slug}` },
  }));
  const tagsRight = nonClothingServiceSegments.map((segment) => ({
    label: segment.name,
    props: { to: `${langPrefix}/${segment.slug}` },
  }));

  const slideDataLeft = clothingServiceSegments.map((segment) => ({
    image: getServiceSegmentImage(segment.assets.default, segment.name),
    src: jpgPath(
      segment.assets.default,
      SERVICE_SEGMENT_IMAGE_WIDTH,
      SERVICE_SEGMENT_IMAGE_HEIGHT,
    ),
  }));

  const slideDataRight = nonClothingServiceSegments.map((segment) => ({
    image: getServiceSegmentImage(segment.assets.default, segment.name),
    src: jpgPath(
      segment.assets.default,
      SERVICE_SEGMENT_IMAGE_WIDTH,
      SERVICE_SEGMENT_IMAGE_HEIGHT,
    ),
  }));

  return (
    <ServiceSegmentsOverview
      slidesLeft={slideDataLeft}
      slidesRight={slideDataRight}
      tagsLeft={tagsLeft}
      tagsRight={tagsRight}
      tagsComponent={Link}
      categoryLeft={navigationLinks.navigation.clothing.name}
      categoryRight={navigationLinks.navigation.nonClothing.name}
      headline={headline}
      theme={theme}
      fadeDelay={4500}
    />
  );
};
